import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodReportSection from "./AbstractPeriodReportSection.js";

/**
 * Section used to render the list of attachments associated to a period report.
 */
export default class AttachmentSection extends AbstractPeriodReportSection {
	getTitle() {
		return _("Attachments");
	}

	accept(visitor) {
		return visitor.visitAttachmentSection(this);
	}

	static getType() {
		return "AttachmentSection";
	}

	static getId() {
		return "attachments";
	}
}
